import { render } from "./Navbar.vue?vue&type=template&id=3d4492b8&bindings={\"logout\":\"options\"}"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"
script.render = render

export default script